import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { messages } from '@/i18n/messages'

Vue.use(VueI18n)

const frNumberFormats = {
  decimal: {
    style: 'decimal',
    separator: ' ',
    delimiter: ',',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  },
  currency: {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol',
    separator: ' ',
    delimiter: ',',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  }
}

const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages,
  numberFormats: {
    fr: frNumberFormats,
    en: frNumberFormats
  }
})

export default i18n
